import Utils from "../utils/utilities"
import { getSingletonInstance } from "../services/singleton-cache"

export default function Run(args?: any): Function {
    return (target: any, propertyKey: string) => {
        args.declarations.forEach(declaration => {
            const dec: any = getSingletonInstance(new declaration())
            if (Utils.isDefined(args) && args.runners && args.runners.length > 0) args.runners.forEach(runner => {
                if (Utils.isDefined(dec[runner])) dec[runner](args)
            })
        })

        if (Utils.isNotEmpty(args.plInitialisations)) {
            args.plInitialisations.forEach(initEvent =>
                window.dispatchEvent(new CustomEvent(initEvent)))
        }
    }
}